import React from 'react';
import classNames from 'classnames';

const RegHeading = (props) => {
    return (
        <h5 className={classNames("font16 font-opensans-bold text-center", { [props.className]: props.className })}>{props.label}</h5>
    )
}
export default React.memo(RegHeading);